module.exports = {"TXTMOB_Resend_code_in_N0":{"id":"TXTMOB_Resend_code_in_N0","defaultMessage":"Saada kood uuesti {0} järel","track":"Resend code in {0}"}}